import { atom } from 'recoil';

const appLanguage = atom({
  key: 'appLanguage',
  default: localStorage.getItem('i18nextLng'),
});

export default appLanguage;
